import type { ApolloClient } from '@apollo/client';
import { auth, signOut } from '@/lib/firebase';
import { clearSsoCookies } from '@/lib/sso-cookies';
import { clearPersistedCache } from '@scio3/graphql-client';
import { useAuthStore } from '@/stores/auth-store';
import { useTeamStore } from '@/stores/team-store';

/** Guard against re-entrant fullLogout calls */
let logoutInProgress = false;

/**
 * Complete logout: clears all auth state, caches, cookies, and subscriptions,
 * then signs out from Firebase.
 */
export async function fullLogout(client: ApolloClient): Promise<void> {
  if (logoutInProgress) return;
  logoutInProgress = true;
  try {
    clearSsoCookies();

    await client.clearStore();
    await clearPersistedCache();

    // Mark explicit logout so routing knows not to restore prior location.
    sessionStorage.setItem('scio3_staff_explicit_logout', '1');

    useAuthStore.getState().clearAuth();
    useTeamStore.getState().clearTeams();
    useTeamStore.persist.clearStorage();

    await signOut(auth);
  } finally {
    logoutInProgress = false;
  }
}
